<template>
  <div class="connect-header-box">
    <avatar :imgSrc="serverAvatar" :size="40" class="serverAvatar" />
    <div class="server-info">
      <span class="nickname">{{ serverAlias }}</span>
      <span class="desc">
        {{ $customerConstant.CUSTOMER_CONSTANT.TITLE }}
      </span>
    </div>
    <button @click="hangupChannel" v-if="showFinishBtn">结束会话</button>
  </div>
</template>

<script>
//连接上之后显示的头部
export default {
  name: "connect-header",
  data() {
    return {
      showFinishBtn: false,
      defult_img: require("src/assets/imgs/server-avatar.jpg")
    };
  },
  computed: {
    ...mapState(["serverAlias", "serverAvatar"])
  },
  methods: {
    ...mapActions({
      hangupChannel: "hangupChannel"
    })
  },
  mounted() {
    this.showFinishBtn = window.location.href.includes("localhost");
  }
};
</script>

<style scoped lang="less">
.connect-header-box {
  display: flex;
  justify-content: flex-start;
  .serverAvatar {
    margin-right: 15px;
  }
  .server-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: var(--connect-header-color);
    .nickname {
      font-weight: 500;
      display: block;
      width: 100%;
      font-family: PingFang TC, sans-serif;
      font-size: 14px;
    }
    .desc {
      font-size: 12px;
      display: block;
      width: 100%;
      font-family: PingFang TC, sans-serif;
      margin-top: 6px;
    }
  }
}
</style>
